<template>
  <div class="common-pagination">
    <div class="paginationLeft">1页{{pageSize}}条，共计{{total}}条</div>
    <!-- hide-on-single-page -->
    <div>
      <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :total="parseInt(total)"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    </div>
    
    
    <!-- :page-sizes.sync="pageSizes" -->
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      required: true
    },
    page: {
      default: 1
    },
    limit: {
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10,20,30]
      }
    },
    layout: {
      type: String,
      default: 'prev, pager, next'
      // default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentPage: {
      get() {
        return parseInt(this.page);
      },
      set(val) {
        this.$emit('update:page', val);
      }
    },
    pageSize: {
      get() {
        return parseInt(this.limit);
      },
      set(val) {
        this.$emit('update:limit', val);
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize });
    }
  }
}
</script>

<style>
.paginationLeft{font-size:12px}
</style>


// WEBPACK FOOTER //
// tablePagination.vue?040a4fd0